export default "__VITE_ASSET__cede4e1c__"